/**
 * Shared helper for reading a module's subscription-based access from the
 * GET /api/v1/users/me/usage response, so paid-feature pages (AI report,
 * preference consultancy, premium mock exams, solutions) stop hardcoding a
 * flat credit price and instead honor an active subscription's
 * unlimited/monthly-quota entitlement first — credit is only the fallback.
 */
export function pickModuleAccess(usage, key) {
  const item = (usage?.modules || []).find((m) => m.module?.key === key);
  if (!item) return { free: false, cost: 0, unlimited: false, remaining: null, quota: null };
  const free = !!item.unlimited || (item.remaining != null && item.remaining > 0);
  return {
    free,
    cost: item.module?.credit_cost || 0,
    unlimited: !!item.unlimited,
    remaining: item.remaining,
    quota: item.quota,
  };
}
